import { render } from "./expdata.vue?vue&type=template&id=1c8b92ad&scoped=true"
import script from "./expdata.vue?vue&type=script&lang=js"
export * from "./expdata.vue?vue&type=script&lang=js"

import "./expdata.vue?vue&type=style&index=0&id=1c8b92ad&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8b92ad"]])

export default __exports__